import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { Spin } from 'antd';

import RefillsList from './RefillsList';
import { SET_REFILLS } from '../../ActionTypes/ActionTypes';

class ActiveRefills extends Component {
    state = {
        loading: false,
    }

    componentDidMount = () => {
        const { setRefills } = this.props;

        this.setState({ loading: true });
        axios({
            method: 'get',
            url: '/carefills/refill_calls_today.json',
            headers: { Authorization: sessionStorage.getItem('jwtToken') },
        })
            .then((response) => {
                console.log(response.data);
                setRefills(response.data.carefills);
                this.setState({
                    loading: false,
                });
            });
    }


    render() {
        const { loading } = this.state;
        return (
            <div>
                {
                    loading
                        ? <Spin />
                        : <RefillsList />
                }
            </div>
        );
    }
}

const mapStateToProps = state => ({
    refillsList: state.RefillState.refillsList,
});

const mapDispatchToProps = dispatch => ({
    setRefills: data => dispatch({ type: SET_REFILLS, payload: { data } }),
});

export default connect(mapStateToProps, mapDispatchToProps)(ActiveRefills);



// WEBPACK FOOTER //
// ./src/component/RefillManagementSystem/ActiveRefills.js